'use client';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import {
  ComponentBlocksLoanCalculators,
  Enum_Componentshareddisplayoptions_Contentswidth,
} from '@/types';

import { CalculatorLayout } from './components';

const CalculatorNotSupported = ({ block }: { block: ComponentBlocksLoanCalculators }) => (
  <CalculatorLayout
    title={block?.CustomCalculatorTitle ?? undefined}
    blurb={block?.CalculatorBlurb}
    backgroundOptions={(block?.CalculatorBackground ?? undefined) as StrapiBackgroundOptions}
    displayOptions={
      {
        ...block?.CalculatorDisplayOptions,
        ContentsWidth:
          block?.CalculatorDisplayOptions?.ContentsWidth ??
          Enum_Componentshareddisplayoptions_Contentswidth.Wide,
        PaddingTop: block?.CalculatorDisplayOptions?.PaddingTop ?? 'md',
        PaddingBottom: block?.CalculatorDisplayOptions?.PaddingBottom ?? 'md',
        PaddingInline: block?.CalculatorDisplayOptions?.PaddingInline ?? 'sm',
      } as StrapiDisplayOptions
    }
    dataComponent="CalculatorNotSupported"
    rowLayout={false}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '12rem',
        width: '100%',
        borderRadius: 4,
        border: '2px dashed',
        borderColor: 'divider',
        p: 4,
      }}
    >
      <Typography variant="body1" color="text.secondary" textAlign="center">
        This calculator is coming soon.
      </Typography>
    </Box>
  </CalculatorLayout>
);

export default CalculatorNotSupported;
